import React from 'react';

export default function ContactForm() {
  return (
    <div className="flex w-full px-4 py-16 lg:p-16 bg-gray-100">
      <div className="flex flex-row flex-wrap w-full lg:-mx-4">
        <form
          method="POST"
          name="Contacto"
          action="https://formsubmit.co/0b6e20a2378c51161821735082712478"
          className="w-full lg:w-1/2 flex flex-wrap flex-col mx-auto bg-white shadow-2xl rounded-lg px-4"
        >
          <div className="flex flex-col flex-wrap mt-4 mb-2 px-8">
            <h3 className="text-2xl text-center">Contacto</h3>
            <div className="mx-auto mt-2 h-2 w-32 bg-blue-700 rounded-full" />
          </div>
          <div className="flex flex-row flex-wrap mb-2 w-full p-4">
            <label
              htmlFor="name"
              className="px-4 flex flex-col w-full lg:w-1/2"
            >
              Nombre y Apellido
              <input
                name="name"
                id="name"
                type="text"
                className="px-4 py-2 bg-gray-100 border border-transparent mt-3 rounded"
              />
            </label>
            <label
              htmlFor="email"
              className="px-4 flex flex-col w-full lg:w-1/2"
            >
              Correo Electrónico
              <input
                name="email"
                id="email"
                type="email"
                className="px-4 py-2 bg-gray-100 border border-transparent mt-3 rounded"
              />
            </label>
          </div>
          <div className="flex flex-row flex-wrap mt-2 mb-4 px-4">
            <label htmlFor="message" className="px-4 flex flex-col w-full">
              Mensaje
              <textarea
                name="message"
                id="message"
                rows={3}
                className="px-4 py-2 bg-gray-100 border border-transparent mt-3 rounded"
              />
            </label>
          </div>
          <div className="flex flex-row flex-wrap mb-4 px-8">
            <button
              type="submit"
              className="px-4 py-1 rounded ml-auto bg-blue-700 text-white"
            >
              Enviar
            </button>
          </div>
          <input type="hidden" name="_replyto" className="hidden" />
          <input type="text" name="_honey" className="hidden" />
        </form>
        <div className="w-full lg:w-1/2 px-4 flex flex-col flex-wrap">
          <article className="w-full mb-4 p-4 flex flex-row justify-center">
            <div className="w-12 h-12 lg:w-20 lg:h-20 rounded-full bg-blue-700 shadow-2xl text-white mx-1 lg:mx-4">
              <a
                href="https://www.facebook.com/groups/137621956388514"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-full flex justify-center items-center text-white"
              >
                <svg
                  className="fill-current h-4 w-4 lg:h-12 lg:w-12 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path d="M15.997 3.985h2.19V.17C17.8.117 16.5 0 14.996 0c-3.16 0-5.323 1.987-5.323 5.64V9H6.187v4.266h3.486V24h4.274V13.267h3.345L17.823 9h-3.877v-2.94c.001-1.233.333-2.077 2.05-2.077z" />
                </svg>
              </a>
            </div>
            <div className="w-12 h-12 lg:w-20 lg:h-20 rounded-full bg-blue-700 shadow-2xl text-white mx-1 lg:mx-4">
              <a
                href="https://twitter.com/SociedadVRID"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-full flex justify-center items-center text-white"
              >
                <svg
                  className="fill-current h-4 w-4 lg:h-12 lg:w-12 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path d="M512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408C411.872 60.704 384.416 48 354.464 48c-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44C46.496 446.88 101.6 464 161.024 464c193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z" />
                </svg>
              </a>
            </div>
            <div className="w-12 h-12 lg:w-20 lg:h-20 rounded-full bg-blue-700 shadow-2xl text-white mx-1 lg:mx-4">
              <a
                href="https://instagram.com/radiologiadentomaxilofacial"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-full flex justify-center items-center text-white"
              >
                <svg
                  className="fill-current h-4 w-4 lg:h-12 lg:w-12 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path d="M352 0H160C71.648 0 0 71.648 0 160v192c0 88.352 71.648 160 160 160h192c88.352 0 160-71.648 160-160V160C512 71.648 440.352 0 352 0zm112 352c0 61.76-50.24 112-112 112H160c-61.76 0-112-50.24-112-112V160C48 98.24 98.24 48 160 48h192c61.76 0 112 50.24 112 112v192zM256 128c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128zm0 208c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80z" />
                  <circle cx="393.6" cy="118.4" r="17.056" />
                </svg>
              </a>
            </div>
          </article>
          <article className="w-full bg-white rounded-lg shadow-2xl mb-4 p-4">
            <div className="flex flex-row flex-wrap w-full h-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 479.058 479.058"
                className="fill-current mr-2 w-4 h-4 text-blue-800 my-auto"
              >
                <path d="M434.146 59.882H44.912C20.146 59.882 0 80.028 0 104.794v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.94c2.034 0 3.97.422 5.738 1.16L239.53 264.63 39.173 90.982c1.77-.736 3.704-1.16 5.738-1.16zm0 299.41H44.912c-8.26 0-14.97-6.7-14.97-14.97V122.615l199.778 173.14c2.822 2.44 6.316 3.655 9.8 3.655a14.95 14.95 0 0 0 9.81-3.655l199.778-173.14v251.65c-.001 8.26-6.71 14.97-14.97 14.97z" />
              </svg>
              <h3 className="text-xl font-semibold text-blue-800">Correo</h3>
            </div>
            <a
              href="mailto:radiologiadentalymaxilofacial@gmail.com"
              className="text-gray-700 hover:text-blue-700"
            >
              radiologiadentalymaxilofacial@gmail.com
            </a>
            <br />
            <a
              href="mailto:radiodentomaxilofacial@yahoo.com"
              className="text-gray-700 hover:text-blue-700"
            >
              radiodentomaxilofacial@yahoo.com
            </a>
          </article>
          <article className="w-full bg-white rounded-lg shadow-2xl mb-4 p-4">
            <div className="flex flex-row flex-wrap w-full h-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="fill-current mr-2 w-4 h-4 text-blue-800 my-auto"
              >
                <path d="M256 0C161.896 0 85.333 76.563 85.333 170.667c0 28.25 7.063 56.26 20.5 81.104L246.667 506.5c1.875 3.396 5.448 5.5 9.333 5.5s7.458-2.104 9.333-5.5L406.23 251.687c13.375-24.76 20.438-52.77 20.438-81.02C426.667 76.563 350.104 0 256 0zm0 256c-47.052 0-85.333-38.28-85.333-85.333S208.948 85.334 256 85.334s85.333 38.28 85.333 85.333S303.052 256 256 256z" />
              </svg>
              <h3 className="text-xl font-semibold text-blue-800">Ubicación</h3>
            </div>
            <a
              href="https://goo.gl/maps/zQUceL43Hnhkb48v8"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-700"
            >
              Edificio Clinica Felix Boada, Calle Bolivar, Nº 59, Baruta –
              Caracas – Venezuela
            </a>
          </article>
        </div>
      </div>
    </div>
  );
}
